<template>
  <div style="border: 0px solid white; height: 100vh; display: flex; position: relative; align-items: center;">
    <BackgroundComponent></BackgroundComponent>
    <div class="queueCont" @mouseenter="closeButton = 'queue'" @mouseleave="closeButton = null">
        <ArtistFeedComponent></ArtistFeedComponent>
        <div v-if="closeButton == 'queue' && queueStore.isQueueVisible && queueStore.queue.length" class="close-btn" @click="queueStore.isQueueVisible = false">
          Close
        </div>
    </div>
    <div class="centerCont">
      <div v-show="isNowPlaying" id="player" style="position: absolute; margin: auto; margin-top: 10vh; z-index: 10; border: 0px solid white; left: 0; right: 0;"></div>
      <div style="height: 10%; border: 0px solid white; display: flex; align-items: center;">
        <v-icon @click="goBack()" class="glass" style="border: 1px solid white; padding: 2%; border-radius: 50%; color: white; cursor: pointer;">mdi-chevron-left</v-icon>
        <v-icon @click="goForward()" class="glass" style="border: 1px solid white; padding: 2%; border-radius: 50%; color: white; cursor: pointer; margin-left: 1vw;">mdi-chevron-right</v-icon>
      </div>
      <div v-if="!userStore.loadingUserInfo" style="height: 90%;">
        <router-view v-slot="{ Component }">
          <keep-alive max="5">
            <component :is="Component" :key="$route.name" />
          </keep-alive>
        </router-view>
      </div>
      <div v-else style="height: 100%;">
        <v-skeleton-loader class="custom-speed" type="heading" color="#80808027" height="100%"></v-skeleton-loader>
      </div>
    </div>
    <div class="lrcCont" @mouseenter="closeButton='lyrics'" @mouseleave="null">
        <LyricsComponent v-if="queueStore.isLyricsVisible && queueStore.queue.length"></LyricsComponent>
        <GenreComponent v-else></GenreComponent>
        <div v-if="closeButton=='lyrics' && queueStore.isLyricsVisible" class="close-btn" @click="queueStore.isLyricsVisible = false">
          Close
        </div>
    </div>
  </div>
  <div>
    <transition name="fade">
      <PlayerComponent v-show="queue.length || isPlaying"></PlayerComponent>
    </transition>
  </div>
  <AddToPlaylistDialog />
</template>

<script>
import { useQueueStore } from './stores/queue';
import { useUserStore } from './stores/user';
import { EventBus } from './eventBus';
import { useToast } from 'vue-toastification';
import { RouterView } from 'vue-router';
import PlayerComponent from './components/playerComponent.vue';
import QueueComponent from './components/queueComponent.vue';
import LyricsComponent from './components/lyricsComponent.vue';
import BackgroundComponent from './components/backgroundComponent.vue';
import CenterTopBackground from './components/centerTopBackground.vue';
import { ref } from 'vue';
import ArtistFeedComponent from './components/artistFeedComponent.vue';
import GenreComponent from './components/genreComponent.vue';
import AddToPlaylistDialog from './components/addToPlaylistDialog.vue';
export default {
  name: 'App',
  components: {
    PlayerComponent,
    RouterView,
    QueueComponent,
    LyricsComponent,
    BackgroundComponent,
    CenterTopBackground,
    ArtistFeedComponent,
    GenreComponent,
    AddToPlaylistDialog
  },
  setup() {
    // Access the store in setup (reactive by default)
    const queueStore = useQueueStore();
    const userStore = useUserStore();
    return { queueStore, userStore }; // Expose to template
  },
  data: () => {
    return {
      toast: useToast(),
      searchQuery: null,
      isLoading: false,
      songQuery: null,
      queue: [],
      searchRes: [],
      isPlaying: false,
      bgHTML: ref(''),
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      closeButton: null,
    }
  },
  methods: {
    searchSong: debounce(function (query) {
      if (!query) {
        return;
      }
      if (query.length) {
        this.$router.push({ path: '/search', query: { q: query } });
      }
    }, 700),
    executeSearch() {
      // 1. Clean the query
      const query = this.songQuery?.trim();

      // 2. Don't search if it's empty
      if (!query) return;

      // 3. Navigate to search page
      this.$router.push({
        path: '/search',
        query: { q: query }
      }).catch(err => {
        // Ignore errors if navigating to the exact same URL/query
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    greetUser() {
      const hour = new Date().getHours();
      if (hour < 12) {
        return `Good morning ${this.userStore.user.name.split(" ")[0]}`;
      } else if (hour < 18) {
        return `Good afternoon ${this.userStore.user.name.split(" ")[0]}`;
      } else {
        return `Good evening ${this.userStore.user.name.split(" ")[0]}`;
      }
    },
    placeholder(){
      if(this.userStore?.user?.name){
        return `What do you want to play ${this.userStore.user.name.split(" ")[0].toLowerCase()}?`;
      } else {
        return 'What do you want to play?';
      }
    },
    goBack() {
      if(window.history.state && window.history.state.back){
          this.$router.back();
      } else{
          this.$router.push({ name: 'home' });
      }
    },
    goForward() {
      if (window.history.state && window.history.state.forward) {
        this.$router.forward();
      }
    }
  },
  watch: {
    songQuery(val) {
      if (!val) {
        this.searchRes = [];
      }
    },
    $route(val){
      const iframe = document.getElementById('player');
      if(val.name == 'NowPlaying'){
        iframe.style.display = 'block';
      } else {
        iframe.style.display = 'none';
      }
    }
  },
  mounted() {
    EventBus.on('searchQuery', (query) => {
      this.songQuery = query;
    })
    EventBus.on('loading_0', () => {
      this.isLoading = false;
    })
    EventBus.on('loading_1', () => {
      this.isLoading = true;
    })
    EventBus.on('queue', (val) => {
      this.queue = val;
    }),
      EventBus.on('isPlaying', (val) => {
        this.isPlaying = val;
      })
    if (window.innerWidth < 675) {
      this.queueStore.isQueueVisible = false;
      this.queueStore.isLyricsVisible = false;
    }
  }
}

function debounce(func, delay) {
  let timer;
  return function (...args) {
    const queryString = args[0]?.trim()
    this.searchQuery = queryString?.length ? queryString : null;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
</script>

<style>
html {
  overflow: hidden;
  margin: 0px;
  padding: 0px;
  height: 100%;
}

body {
  overflow: hidden;
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  /* For WebKit-based browsers */
  -moz-osx-font-smoothing: grayscale;
  /* For macOS */
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* font-family: "Ubuntu", sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #000;
  height: 100vh;
}

.input {
  color: white;
  width: 100%;
  border: 0px solid yellow;
}

.centerTopCont>div:nth-child(2) {
  width: 100%;
  height: 5vh;
  border: 0px solid red;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.centerTopCont>div:nth-child(2)>div {
  /* border: 1px solid yellow; */
  display: inline-block;
  color: white;
  padding: 0.5vw 1.5vw;
}

.img-cont {
  height: 200px;
  margin: auto;
  width: 200px;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}

.thumbnail {
  position: absolute;
  /* Position the image absolutely */
  top: 50%;
  /* Align the image to the vertical center */
  left: 50%;
  /* Align the image to the horizontal center */
  transform: translate(-50%, -50%);
  /* Center the image properly */
  height: 105%;
  /* Set the height to fill the div */
  width: 100%;
  /* Set the width to fill the div */
  object-fit: cover;
}

.centerCont {
  position: relative;
  border: 0px solid white;
  width: 57%;
  min-width: 0px;
  height: 98vh;
  z-index: 10;
  border-radius: 14px;
}

.centerTopCont {
  border: 0px solid green;
  height: 12vh;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}

@keyframes textAnimate {
  0% {
    stroke-dasharray: 0 50%;
    stroke-dashoffset: 20%;
    fill: #ffffff
  }

  100% {
    stroke-dasharray: 50% 0;
    stroke-dashoffset: -20%;
    fill: #000
  }

}

.withplayer {
  height: 76vh;
  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 20%);
  -webkit-mask-image: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 20%);
}

.withoutplayer {
  height: 88vh;
}

.imgFade-enter-active,
.imgFade-leave-active {
  transition: opacity 0.25s ease,
}

.imgFade-enter-from {
  opacity: 0;
}

.imgFade-enter-to,
.imgFade-leave-from {
  opacity: 1;
}

.imgFade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from {
  transform: translateX(-100%);
}

.slide-leave-to {
  transform: translateX(-100%);
}

.slideRight-enter-active,
.slideRight-leave-active {
  transition: transform 0.3s ease;
}

.slideRight-enter-from {
  transform: translateX(100%);
}

.slideRight-leave-to {
  transform: translateX(100%);
}

/* Hover functionality for delete icon */
.v-list-item:hover .delete-icon {
  visibility: visible;
}

/* Apply hover behavior for each individual item */
.v-list-item:hover {
  cursor: pointer;
}

.v-list-item {
  position: relative;
}

/* Optional: Prevent visibility flashing effect */
.v-list-item:hover .v-icon {
  visibility: visible;
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.queueCont,
.lrcCont {
    position: relative;

    width: 25%;
    min-width: 0;
    height: 100vh;

    z-index: 1;

    display: flex;
    justify-content: center;
    align-items: center;
}


.close-btn {
    position: absolute;

    bottom: 2vh;
    left: 5%;

    width: 90%;
    height: 5vh;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    z-index: 100;

    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;

    color: white;

    transition:
        background 0.25s ease,
        border-color 0.25s ease;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 255, 255, 0.2);
}

.leftSticker {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 25vw;
  height: auto;
  z-index: 1001;
  display: flex;
  justify-content: left;
}

.rightSticker {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 25vw;
  height: auto;
  z-index: 1001;
  display: flex;
  justify-content: right;
}

.header {
  font-size: 2.3rem;
  font-weight: 70;
  letter-spacing: 2px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

@keyframes hue {
  from {
    -webkit-filter: hue-rotate(0deg);
  }

  to {
    -webkit-filter: hue-rotate(-360deg);
  }
}

.glass {
  /* display: flex; */
  align-items: center;
  background: #ffffff0d;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 50px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  color: white;
  transition: background 0.3s ease;
}

.glass:hover {
  background: rgba(255, 255, 255, 0.1);
}


@media (max-width: 675px) {
  svg {
    width: 100%;
  }

  .head_s {
    margin: auto;
  }

  .centerCont {
    width: 100%;
  }

  .centerTopCont {
    height: 30vh;
  }

  .withplayer {
    height: 50vh;
  }

  .withoutplayer {
    height: 70vh;
  }

  .queueCont {
    position: absolute;
    width: 100%;
  }

  .lrcCont {
    position: absolute;
    width: 100%;
  }

}

.loader {
  width: 48px;
  height: 40px;
  margin-top: 30px;
  display: inline-block;
  position: relative;
  background: #FFF;
  border-radius: 15% 15% 35% 35%;
}

.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 45px;
  top: 8px;
  border: 4px solid #FFF;
  width: 16px;
  height: 20px;
  border-radius: 0 4px 4px 0;
}

.loader::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 10px;
  color: #FFF;
  top: -15px;
  left: 11px;
  box-sizing: border-box;
  animation: animloader 1s ease infinite;
}

.custom-speed :deep(.v-skeleton-loader__bone::after) {
  animation-duration: 5s !important; /* Default is usually 1.5s to 2s */
}

@keyframes animloader {
  0% {
    box-shadow: 2px 0px rgba(255, 255, 255, 0), 12px 0px rgba(255, 255, 255, 0.3), 20px 0px rgba(255, 255, 255, 0);
  }

  50% {
    box-shadow: 2px -5px rgba(255, 255, 255, 0.5), 12px -3px rgba(255, 255, 255, 0.5), 20px -2px rgba(255, 255, 255, 0.6);
  }

  100% {
    box-shadow: 2px -8px rgba(255, 255, 255, 0), 12px -5px rgba(255, 255, 255, 0), 20px -5px rgba(255, 255, 255, 0);
  }
}
</style>
